import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation } from "react-router-dom";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { _Api } from "../api/_call";
import { formatDate } from "../../common/helpers/formatDate";
import { useSelector } from 'react-redux';
import { error } from '../../common/helpers/toastify';
import { useTranslation } from 'react-i18next';
import TableLoader from '../../../admin/common/TableLoader';

const normalizeShapeId = (raw) => {
  if (raw == null || raw === "") return "";
  if (typeof raw === "object" && raw.$oid != null) return String(raw.$oid);
  return String(raw);
};

/** Stable id for facet chips — avoids DOM `[object Object]` when `_id` is a plain object. */
const facetRowId = (result, index) => {
  const oid =
    result?._id != null && typeof result._id === "object" && result._id.$oid != null
      ? String(result._id.$oid)
      : result?._id != null && typeof result._id !== "object"
      ? String(result._id)
      : "";
  if (oid && oid !== "[object Object]") return oid;
  if (result?.code != null && String(result.code) !== "") return String(result.code);
  return `row-${index}`;
};

export const DaimondSearchModal = (props) => {
  const { defaultFilterExpanded = true, mixMatchFlow: mixMatchFlowProp } = props;
  const dataFetched = useRef();
  const { t } = useTranslation();
  const { state } = useLocation()
  const customer = useSelector((state) => state.app.customer)
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const [daimondfilter, setDaimondfilters] = useState();
  const [cut, setCut] = useState([]);
  const [clarity, setClarity] = useState([]);
  const [stonecolor, setStonecolors] = useState([]);
  const [polish, setPolish] = useState([]);
  const [symmetry, setSymmetry] = useState([]);
  const [fluorescence, setFluorescence] = useState([]);
  const [lbs, setLbs] = useState([]);
  const [Status, setStatus] = useState([]);
  const [shape, setShape] = useState([]);
  const [comparisiondata, setComparisiondata] = useState('');
  const [comparisionLoader, setComparisionLoader] = useState(true);
  const [items, setItems] = useState([]);
  const [totalresult, setTotalresult] = useState();
  const [rowlength, setRowlength] = useState(0);
  const [val1, setVal1] = useState([47, 900]);
  const [val2, setVal2] = useState([0.10, 4.00]);
  const [val3, setVal3] = useState([45, 86]);
  const [val4, setVal4] = useState([45, 86]);
  const [showLoader, setShowloader] = useState(false);
  let limit = 20;

  const toggleListId = (setter, idRaw) => {
    const idStr = normalizeShapeId(idRaw);
    if (!idStr) return;
    setter((current) => {
      const on = current.some((item) => normalizeShapeId(item) === idStr);
      if (on) return current.filter((item) => normalizeShapeId(item) !== idStr);
      return [...current, idStr];
    });
  };

  const callfilters = (event, label) => {
    const target = event?.target;
    if (!target) return;

    const chipFacetId = target?.getAttribute?.("data-facet-id");

    if (label === "cut") {
      toggleListId(setCut, chipFacetId);
    } else if (label === "clarity") {
      toggleListId(setClarity, chipFacetId);
    } else if (label === "stonecolor") {
      toggleListId(setStonecolors, chipFacetId);
    } else if (label === "polish") {
      toggleListId(setPolish, chipFacetId);
    } else if (label === "symmetry") {
      toggleListId(setSymmetry, chipFacetId);
    } else if (label === "fluorescence") {
      toggleListId(setFluorescence, chipFacetId);
    } else if (label === "lbs") {
      const v = target.value;
      setLbs((current) =>
        current.includes(v) ? current.filter((item) => item !== v) : [...current, v]
      );
    } else if (label === "status") {
      const v = String(target.value);
      setStatus((current) =>
        current.some((item) => String(item) === v)
          ? current.filter((item) => String(item) !== v)
          : [...current, v]
      );
    } else if (label === "shape") {
      const idStr = normalizeShapeId(event.currentTarget.getAttribute("data-id"));
      if (!idStr) return;
      setShape((current) => {
        const exists = current.some((s) => normalizeShapeId(s) === idStr);
        if (exists) return current.filter((s) => normalizeShapeId(s) !== idStr);
        return [...current, idStr];
      });
    }
  };
  const submitfilters = async () => {
    // if (!customer?.id) {
    //   error(t('Customer is Requried!!'))
    //   return
    // }
    const integerArray = Status.map(Number);
    setTotalresult(0)
    try {
      const posdata = {
        length: 0,
        limit: limit,
        skip: 0,
        "CUT": cut,
        "Clarity": clarity,
        "Stonecolor": stonecolor,
        "Polish": polish,
        "Symmetry": symmetry,
        "fluorescence": fluorescence,
        "Lbs": lbs,
        "Status": integerArray,
        "Shape": shape,
        "Price": [{ "min": val1[0], "max": val1[1] }],
        "Carat": [{ "min": val2[0], "max": val2[1] }],
        "Depth": [{ "min": val3[0], "max": val3[1] }],
        "Table": [{ "min": val4[0], "max": val4[1] }],
        "customer_id": customer?.id,
        "type": "mix_match"
      }
      let res = await _Api(posdata, `api/v1/POS/diamond/getList`);
      if (res.code === 200) {
        setItems(res.data);
        setTotalresult(res.totalResult);
        setRowlength(0)
      }
    } catch (err) {
      console.log(err, 'err');
    }
  }
  const fetchMoreData = () => {
    // if (!customer?.id) {
    //   error(t('Customer is Requried!!'))
    //   return
    // }
    var len = rowlength + limit;
    setRowlength(len);
    const integerArray = Status.map(Number);
    setTimeout(async () => {
      try {
        const posdata = {
          length: len,
          limit: limit,
          skip: len,
          "CUT": cut,
          "Clarity": clarity,
          "Stonecolor": stonecolor,
          "Polish": polish,
          "Symmetry": symmetry,
          "fluorescence": fluorescence,
          "Lbs": lbs,
          "Status": integerArray,
          "Shape": shape,
          "Price": [{ "min": val1[0], "max": val1[1] }],
          "Carat": [{ "min": val2[0], "max": val2[1] }],
          "Depth": [{ "min": val3[0], "max": val3[1] }],
          "Table": [{ "min": val4[0], "max": val4[1] }],
          "customer_id": customer?.id,
          "type": "mix_match"
        }
        let res = await _Api(posdata, `api/v1/POS/diamond/getList`);
        if (res.code === 200) {
          setItems(items.concat(res.data));
        }
      } catch (err) {
        console.log(err, 'err');
      }
    }, 1200);
  };

  const callcomparision = (event) => {
    const data = [...comparisiondata];
    var newState = [...items]
    if (event.target.checked) {
      newState.filter((itemdata) => itemdata._id === event.target.id).forEach((result) => {
        data.push(result);
      })
      setComparisiondata(data);
      setComparisionLoader(false);
    } else {
      setComparisiondata(comparisiondata.filter((v) => v._id !== event.target.id));
      setComparisionLoader(false);
    }
  }

  const isFacetIdSelected = (list, idRaw) =>
    idRaw != null &&
    list.some((s) => normalizeShapeId(s) === normalizeShapeId(idRaw));

  const deletecomparision = (id) => {
    var checkboxitem = document.querySelector('[data-id="d' + id + '"]');
    if (checkboxitem.checked) {
      checkboxitem.checked = false;
    }
    setComparisiondata(comparisiondata.filter((v) => v._id !== id));
    setComparisionLoader(false)
  }
  const clearSection = (section) => {
    switch (section) {
      case "shape":
        setShape([]);
        break;
      case "price":
        if (daimondfilter?.Price) {
          setVal1([daimondfilter.Price.min, daimondfilter.Price.max]);
        }
        break;
      case "carat":
        if (daimondfilter?.Carat) {
          setVal2([daimondfilter.Carat.min, daimondfilter.Carat.max]);
        }
        break;
      case "depth":
        if (daimondfilter?.Depth) {
          setVal3([daimondfilter.Depth.min, daimondfilter.Depth.max]);
        }
        break;
      case "table":
        if (daimondfilter?.Table) {
          setVal4([daimondfilter.Table.min, daimondfilter.Table.max]);
        }
        break;
      case "stonecolor":
        setStonecolors([]);
        break;
      case "clarity":
        setClarity([]);
        break;
      case "cut":
        setCut([]);
        break;
      case "polish":
        setPolish([]);
        break;
      case "symmetry":
        setSymmetry([]);
        break;
      case "fluorescence":
        setFluorescence([]);
        break;
      case "lab":
        setLbs([]);
        break;
      case "status":
        setStatus([]);
        break;
      default:
        break;
    }
  };
  const daimondfilters = async (lable) => {
    // if (!customer?.id) {
    //   error(t('Customer is Requried!!'))
    //   return
    // }
    setShowloader(true);
    try {
      const posdata = {}
      let res = await _Api(posdata, `api/v1/Inventory/diamond/getFilters`);
      if (res.code === 200) {
        let shapes = [], colors = [], cuts = [], polishs = [], claritys = [], symmetrys = [], fluorescences = [], lbss = [], status = [], Price = [], Carat = [], Depth = [], Table = [];
        setCut([]); setShape([]); setStonecolors([]); setClarity([]); setPolish([]); setSymmetry([]); setFluorescence([]); setLbs([]); setStatus([]);
        setDaimondfilters(res.data);
        if (res.data?.Shape?.length) {
          const shapeIds = res.data.Shape.map((r) => normalizeShapeId(r?._id)).filter(Boolean);
          shapes.push(...shapeIds);
          setShape(shapeIds);
        }

        if (res.data?.StoneColor?.length) {
          const stoneIds = res.data.StoneColor.map((r, i) => facetRowId(r, i));
          colors.push(...stoneIds);
          setStonecolors(stoneIds);
        }
        if (res.data?.Clarity?.length) {
          const clarityIds = res.data.Clarity.map((r, i) => facetRowId(r, i));
          claritys.push(...clarityIds);
          setClarity(clarityIds);
        }
        if (res.data?.Cut?.length) {
          const cutIds = res.data.Cut.map((r, i) => facetRowId(r, i));
          cuts.push(...cutIds);
          setCut(cutIds);
        }
        if (res.data?.Polish?.length) {
          const polishIds = res.data.Polish.map((r, i) => facetRowId(r, i));
          polishs.push(...polishIds);
          setPolish(polishIds);
        }
        if (res.data?.Symmetry?.length) {
          const symIds = res.data.Symmetry.map((r, i) => facetRowId(r, i));
          symmetrys.push(...symIds);
          setSymmetry(symIds);
        }
        if (res.data?.Fluorescence?.length) {
          const flIds = res.data.Fluorescence.map((r, i) => facetRowId(r, i));
          fluorescences.push(...flIds);
          setFluorescence(flIds);
        }
        if (res.data?.Lbs?.length) {
          const labList = [...res.data.Lbs];
          lbss.push(...labList);
          setLbs(labList);
        }
        if (res.data?.Status?.length) {
          const statList = [...res.data.Status];
          statList.forEach((r) => status.push(r));
          setStatus(statList.map((s) => String(s)));
        }
        setVal1([res.data?.Price?.min, res.data?.Price?.max]);
        setVal2([res.data?.Carat?.min, res.data?.Carat?.max]);
        setVal3([res.data?.Depth?.min, res.data?.Depth?.max]);
        setVal4([res.data?.Table?.min, res.data?.Table?.max]);
        Price.push({ "min": res.data?.Price?.min, "max": res.data?.Price?.max });
        Carat.push({ "min": res.data?.Carat?.min, "max": res.data?.Carat?.max });
        Depth.push({ "min": res.data?.Depth?.min, "max": res.data?.Depth?.max });
        Table.push({ "min": res.data?.Table?.min, "max": res.data?.Table?.max });
        if (lable === 'reset') {
          setRowlength(0);
        }
        const integerArray = status.map(Number);
        setTimeout(async () => {
          try {
            const posdata = {
              length: 0,
              limit: limit,
              skip: 0,
              "CUT": cuts,
              "Clarity": claritys,
              "Stonecolor": colors,
              "Polish": polishs,
              "Symmetry": symmetrys,
              "fluorescence": fluorescences,
              "Lbs": lbss,
              "Status": integerArray,
              "Shape": shapes,
              "Price": Price,
              "Carat": Carat,
              "Depth": Depth,
              "Table": Table,
              "customer_id": customer?.id,
              "type": "mix_match"
            }
            let res = await _Api(posdata, `api/v1/POS/diamond/getList`);
            if (res.code === 200) {
              setShowloader(false);
              setItems(res.data);
              setTotalresult(res.totalResult);
              dataFetched.current = false
            }
            else if(res.code===400){
            setShowloader(false);
            dataFetched.current = false
            }
          } catch (err) {
            console.log(err, 'err');
          }
        }, 1000);
      }
    } catch (err) {
      console.log(err, 'err');
    }
  }

  useEffect(() => {
    if (customer?.id) {
      dataFetched.current = false
    }
    if (dataFetched.current) return;
    dataFetched.current = true
    daimondfilters();
    // eslint-disable-next-line 
  }, [customer]);
  return (
    <div className="diamond-search-wrap">
      <div className="diamond-search-wrap-width">
        <div
          className="accordion diamond-search-accordian"
          id="accordionDiamond"
        >
          <div className="diamond-search-accordian-tab">
            <button
              className={`diamond-search-wrap-row diamond-search-accordian-tab-button${
                defaultFilterExpanded ? "" : " collapsed"
              }`}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#diamondSearchTab"
              aria-expanded={defaultFilterExpanded}
              aria-controls="diamondSearchTab"
            >
              <span>
                {" "}
                <img src={base_assets + "images/icons/down-arrow.png"} alt="" />
                {t("Diamond Search")}
              </span>
            </button>
            <button
              onClick={() => {
                daimondfilters("reset");
              }}
              className="diamond-search-accordian-tab-reset"
            >
              <img src={base_assets + "images/icons/reset.png"} alt="" />
              <span>{t("reset filter")}</span>
            </button>
          </div>
          <div
            id="diamondSearchTab"
            className={`accordion-collapse collapse${defaultFilterExpanded ? " show" : ""}`}
            data-bs-parent="#accordionDiamond"
          >
            <div className="diamond-search-wrap-row d-filter">
              <div className="d-filter__main">
                <div className="d-filter__shape">
                  <div className="d-filter__head">
                    <h3 className="d-filter__title">{t("Shape")}</h3>
                    <button
                      type="button"
                      className="d-filter__clear"
                      onClick={() => clearSection("shape")}
                    >
                      {t("Clear")}
                    </button>
                  </div>
                  <div className="d-filter__shape-grid">
                    {daimondfilter?.Shape
                      ? daimondfilter?.Shape.map((result, key) => {
                        const sidNorm = normalizeShapeId(result?._id);
                        const isShapeOn =
                          !!sidNorm && shape.some((s) => normalizeShapeId(s) === sidNorm);
                        return (
                          <div
                            key={sidNorm ? `shape-${sidNorm}` : `shape-${key}`}
                            id={`diamond-shape-tile-${key}`}
                            data-id={sidNorm}
                            onClick={(e) => callfilters(e, "shape")}
                            onKeyDown={(e) => {
                              if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                callfilters(e, "shape");
                              }
                            }}
                            role="button"
                            tabIndex={0}
                            className={`diamond-search-wrap-row-col-diamond-row-single resetshape d-filter__shape-tile${isShapeOn ? " active" : ""}`}
                          >
                            <div className="diamond-search-wrap-row-col-diamond-row-single-img">
                              <img src={result?.logo} alt="" />
                            </div>
                            <p className="diamond-search-wrap-row-col-diamond-row-single-title">
                              {result?.name}
                            </p>
                          </div>
                        );
                      })
                      : ""}
                  </div>
                </div>

                <div className="d-filter__right">
                  <div className="d-filter__row">
                    <div className="d-filter__section d-filter__section--wide d-filter__section--slider">
                      <div className="d-filter__head">
                        <h3 className="d-filter__title">{t("Price")}</h3>
                        <button
                          type="button"
                          className="d-filter__clear"
                          onClick={() => clearSection("price")}
                        >
                          {t("Clear")}
                        </button>
                      </div>
                      <div className="range-area d-filter__range">
                        <Slider
                          range
                          min={daimondfilter?.Price?.min}
                          max={daimondfilter?.Price?.max}
                          value={val1}
                          onChange={setVal1}
                          step={0.1}
                        />
                        <div className="d-filter__range-inputs">
                          <div className="d-filter__range-input">
                            <span className="d-filter__range-currency">
                              {daimondfilter?.currency}
                            </span>
                            <span className="d-filter__range-value">{val1[0]}</span>
                          </div>
                          <div className="d-filter__range-input">
                            <span className="d-filter__range-currency">
                              {daimondfilter?.currency}
                            </span>
                            <span className="d-filter__range-value">{val1[1]}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="d-filter__section">
                      <div className="d-filter__head">
                        <h3 className="d-filter__title">{t("Color")}</h3>
                        <button
                          type="button"
                          className="d-filter__clear"
                          onClick={() => clearSection("stonecolor")}
                        >
                          {t("Clear")}
                        </button>
                      </div>
                      <div className="diamond-tab-row d-filter__chips">
                        {daimondfilter?.StoneColor
                          ? daimondfilter?.StoneColor.map((result, key) => {
                            const fid = facetRowId(result, key);
                            const inputId = `df-sc-${key}-${fid.replace(/\W/g, "_")}`;
                            return (
                              <React.Fragment key={inputId}>
                                <input
                                  id={inputId}
                                  data-facet-id={fid}
                                  value={result?.code}
                                  type="checkbox"
                                  checked={isFacetIdSelected(stonecolor, fid)}
                                  onChange={(e) => callfilters(e, "stonecolor")}
                                />
                                <label
                                  htmlFor={inputId}
                                  className={`diamond-tab-row-tab resetcolor d-filter__chip${
                                    isFacetIdSelected(stonecolor, fid) ? " active" : ""
                                  }`}
                                >
                                  {result?.code}
                                </label>
                              </React.Fragment>
                            );
                          })
                          : ""}
                      </div>
                    </div>

                    <div className="d-filter__section">
                      <div className="d-filter__head">
                        <h3 className="d-filter__title">{t("Clarity")}</h3>
                        <button
                          type="button"
                          className="d-filter__clear"
                          onClick={() => clearSection("clarity")}
                        >
                          {t("Clear")}
                        </button>
                      </div>
                      <div className="diamond-tab-row d-filter__chips">
                        {daimondfilter?.Clarity
                          ? daimondfilter?.Clarity.map((result, key) => {
                            const fid = facetRowId(result, key);
                            const inputId = `df-cl-${key}-${fid.replace(/\W/g, "_")}`;
                            return (
                              <React.Fragment key={inputId}>
                                <input
                                  id={inputId}
                                  data-facet-id={fid}
                                  value={result?.code}
                                  type="checkbox"
                                  checked={isFacetIdSelected(clarity, fid)}
                                  onChange={(e) => callfilters(e, "clarity")}
                                />
                                <label
                                  htmlFor={inputId}
                                  className={`diamond-tab-row-tab resetclarity d-filter__chip${
                                    isFacetIdSelected(clarity, fid) ? " active" : ""
                                  }`}
                                >
                                  {result?.code}
                                </label>
                              </React.Fragment>
                            );
                          })
                          : ""}
                      </div>
                    </div>
                  </div>

                  <div className="d-filter__row">
                    <div className="d-filter__section d-filter__section--wide d-filter__section--slider">
                      <div className="d-filter__head">
                        <h3 className="d-filter__title">{t("Carat")}</h3>
                        <button
                          type="button"
                          className="d-filter__clear"
                          onClick={() => clearSection("carat")}
                        >
                          {t("Clear")}
                        </button>
                      </div>
                      <div className="range-area d-filter__range">
                        <Slider
                          range
                          min={daimondfilter?.Carat?.min}
                          max={daimondfilter?.Carat?.max}
                          value={val2}
                          onChange={setVal2}
                          step={0.1}
                        />
                        <div className="d-filter__range-inputs">
                          <div className="d-filter__range-input">
                            <span className="d-filter__range-value">{val2[0]}</span>
                            <span className="d-filter__range-currency">{t("Ct")}</span>
                          </div>
                          <div className="d-filter__range-input">
                            <span className="d-filter__range-value">{val2[1]}</span>
                            <span className="d-filter__range-currency">{t("Ct")}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="d-filter__section d-filter__section--wide">
                      <div className="d-filter__head">
                        <h3 className="d-filter__title">{t("Cut")}</h3>
                        <button
                          type="button"
                          className="d-filter__clear"
                          onClick={() => clearSection("cut")}
                        >
                          {t("Clear")}
                        </button>
                      </div>
                      <div className="diamond-tab-row d-filter__chips">
                        {daimondfilter?.Cut
                          ? daimondfilter?.Cut.map((result, key) => {
                            const fid = facetRowId(result, key);
                            const inputId = `df-cut-${key}-${fid.replace(/\W/g, "_")}`;
                            return (
                              <React.Fragment key={inputId}>
                                <input
                                  id={inputId}
                                  data-facet-id={fid}
                                  value={result?.code}
                                  type="checkbox"
                                  checked={isFacetIdSelected(cut, fid)}
                                  onChange={(e) => callfilters(e, "cut")}
                                />
                                <label
                                  htmlFor={inputId}
                                  className={`diamond-tab-row-tab resetcut d-filter__chip${
                                    isFacetIdSelected(cut, fid) ? " active" : ""
                                  }`}
                                >
                                  {result?.code}
                                </label>
                              </React.Fragment>
                            );
                          })
                          : ""}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="accordion advanced-options-accordian"
              id="accordionAdvanced"
            >
              <div
                id="advancedOptions"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionAdvanced"
              >
                <div className="diamond-search-wrap-row d-filter d-filter--advanced">
                  <div className="d-filter__main">
                    <div className="d-filter__right">
                      <div className="d-filter__row">
                        <div className="d-filter__section d-filter__section--wide d-filter__section--slider">
                          <div className="d-filter__head">
                            <h3 className="d-filter__title">{t("Depth")}</h3>
                            <button
                              type="button"
                              className="d-filter__clear"
                              onClick={() => clearSection("depth")}
                            >
                              {t("Clear")}
                            </button>
                          </div>
                          <div className="range-area d-filter__range">
                            <Slider
                              range
                              min={daimondfilter?.Depth?.min}
                              max={daimondfilter?.Depth?.max}
                              value={val3}
                              onChange={setVal3}
                            />
                            <div className="d-filter__range-inputs">
                              <div className="d-filter__range-input">
                                <span className="d-filter__range-value">{val3[0]}</span>
                                <span className="d-filter__range-currency">%</span>
                              </div>
                              <div className="d-filter__range-input">
                                <span className="d-filter__range-value">{val3[1]}</span>
                                <span className="d-filter__range-currency">%</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="d-filter__section d-filter__section--wide d-filter__section--slider">
                          <div className="d-filter__head">
                            <h3 className="d-filter__title">{t("Table")}</h3>
                            <button
                              type="button"
                              className="d-filter__clear"
                              onClick={() => clearSection("table")}
                            >
                              {t("Clear")}
                            </button>
                          </div>
                          <div className="range-area d-filter__range">
                            <Slider
                              range
                              min={daimondfilter?.Table?.min}
                              max={daimondfilter?.Table?.max}
                              value={val4}
                              onChange={setVal4}
                            />
                            <div className="d-filter__range-inputs">
                              <div className="d-filter__range-input">
                                <span className="d-filter__range-value">{val4[0]}</span>
                                <span className="d-filter__range-currency">%</span>
                              </div>
                              <div className="d-filter__range-input">
                                <span className="d-filter__range-value">{val4[1]}</span>
                                <span className="d-filter__range-currency">%</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="d-filter__section">
                          <div className="d-filter__head">
                            <h3 className="d-filter__title">{t("Polish")}</h3>
                            <button
                              type="button"
                              className="d-filter__clear"
                              onClick={() => clearSection("polish")}
                            >
                              {t("Clear")}
                            </button>
                          </div>
                          <div className="diamond-tab-row d-filter__chips">
                            {daimondfilter?.Polish
                              ? daimondfilter?.Polish.map((result, key) => {
                                const fid = facetRowId(result, key);
                                const inputId = `df-pl-${key}-${fid.replace(/\W/g, "_")}`;
                                return (
                                  <React.Fragment key={inputId}>
                                    <input
                                      id={inputId}
                                      data-facet-id={fid}
                                      value={result?.code}
                                      type="checkbox"
                                      checked={isFacetIdSelected(polish, fid)}
                                      onChange={(e) => callfilters(e, "polish")}
                                    />
                                    <label
                                      htmlFor={inputId}
                                      className={`diamond-tab-row-tab resetpolish d-filter__chip${
                                        isFacetIdSelected(polish, fid) ? " active" : ""
                                      }`}
                                    >
                                      {result?.code}
                                    </label>
                                  </React.Fragment>
                                );
                              })
                              : ""}
                          </div>
                        </div>

                        <div className="d-filter__section">
                          <div className="d-filter__head">
                            <h3 className="d-filter__title">{t("Symmetry")}</h3>
                            <button
                              type="button"
                              className="d-filter__clear"
                              onClick={() => clearSection("symmetry")}
                            >
                              {t("Clear")}
                            </button>
                          </div>
                          <div className="diamond-tab-row d-filter__chips">
                            {daimondfilter?.Symmetry
                              ? daimondfilter?.Symmetry.map((result, key) => {
                                const fid = facetRowId(result, key);
                                const inputId = `df-sy-${key}-${fid.replace(/\W/g, "_")}`;
                                return (
                                  <React.Fragment key={inputId}>
                                    <input
                                      id={inputId}
                                      data-facet-id={fid}
                                      value={result?.code}
                                      type="checkbox"
                                      checked={isFacetIdSelected(symmetry, fid)}
                                      onChange={(e) => callfilters(e, "symmetry")}
                                    />
                                    <label
                                      htmlFor={inputId}
                                      className={`diamond-tab-row-tab resetsymmetry d-filter__chip${
                                        isFacetIdSelected(symmetry, fid) ? " active" : ""
                                      }`}
                                    >
                                      {result?.code}
                                    </label>
                                  </React.Fragment>
                                );
                              })
                              : ""}
                          </div>
                        </div>

                      </div>

                      <div className="d-filter__row">
                        <div className="d-filter__section">
                          <div className="d-filter__head">
                            <h3 className="d-filter__title">{t("Fluorescence")}</h3>
                            <button
                              type="button"
                              className="d-filter__clear"
                              onClick={() => clearSection("fluorescence")}
                            >
                              {t("Clear")}
                            </button>
                          </div>
                          <div className="diamond-tab-row d-filter__chips">
                            {daimondfilter?.Fluorescence
                              ? daimondfilter?.Fluorescence.map((result, key) => {
                                const fid = facetRowId(result, key);
                                const inputId = `df-fl-${key}-${fid.replace(/\W/g, "_")}`;
                                return (
                                  <React.Fragment key={inputId}>
                                    <input
                                      id={inputId}
                                      data-facet-id={fid}
                                      value={result?.code}
                                      type="checkbox"
                                      checked={isFacetIdSelected(fluorescence, fid)}
                                      onChange={(e) => callfilters(e, "fluorescence")}
                                    />
                                    <label
                                      htmlFor={inputId}
                                      className={`diamond-tab-row-tab resetfluorescence d-filter__chip${
                                        isFacetIdSelected(fluorescence, fid) ? " active" : ""
                                      }`}
                                    >
                                      {result?.code}
                                    </label>
                                  </React.Fragment>
                                );
                              })
                              : ""}
                          </div>
                        </div>

                        <div className="d-filter__section">
                          <div className="d-filter__head">
                            <h3 className="d-filter__title">{t("Lab")}</h3>
                            <button
                              type="button"
                              className="d-filter__clear"
                              onClick={() => clearSection("lab")}
                            >
                              {t("Clear")}
                            </button>
                          </div>
                          <div className="diamond-tab-row d-filter__chips">
                            {daimondfilter?.Lbs
                              ? daimondfilter?.Lbs.map((result, key) => {
                                const lbOn = lbs.includes(result);
                                return (
                                  <React.Fragment key={key}>
                                    <input
                                      id={"Lbs" + key}
                                      value={result}
                                      type="checkbox"
                                      checked={lbOn}
                                      onChange={(e) => callfilters(e, "lbs")}
                                    />
                                    <label
                                      htmlFor={"Lbs" + key}
                                      id={"lLbs" + key}
                                      className={`diamond-tab-row-tab text-uppercase resetlab d-filter__chip${
                                        lbOn ? " active" : ""
                                      }`}
                                    >
                                      {result}
                                    </label>
                                  </React.Fragment>
                                );
                              })
                              : ""}
                          </div>
                        </div>

                        <div className="d-filter__section">
                          <div className="d-filter__head">
                            <h3 className="d-filter__title">{t("Status")}</h3>
                            <button
                              type="button"
                              className="d-filter__clear"
                              onClick={() => clearSection("status")}
                            >
                              {t("Clear")}
                            </button>
                          </div>
                          <div className="diamond-tab-row d-filter__chips">
                            {daimondfilter?.Status
                              ? daimondfilter?.Status.sort((a, b) => a - b).map((result, key) => {
                                const stOn = Status.some((s) => String(s) === String(result));
                                return (
                                  <React.Fragment key={key}>
                                    <input
                                      id={result}
                                      value={result}
                                      type="checkbox"
                                      checked={stOn}
                                      onChange={(e) => callfilters(e, "status")}
                                    />
                                    <label
                                      htmlFor={result}
                                      id={"status" + result}
                                      className={`diamond-tab-row-tab resetstatus d-filter__chip${
                                        stOn ? " active" : ""
                                      }`}
                                    >
                                      {result === "1"
                                        ? "Stock"
                                        : result === "2"
                                        ? "Reserve"
                                        : result === "3"
                                        ? "Custom Order"
                                        : result === "4"
                                        ? "Transits"
                                        : ""}
                                    </label>
                                  </React.Fragment>
                                );
                              })
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="advanced-options-accordian-button-wrap">
                <div className="row justify-content-center m-0">
                  <div className="col-md-3">
                    <button className=" w-100 com-btn mt-2 mb-2 submit-filter-btn" onClick={submitfilters}>{t("Submit Filter")}</button>
                  </div>
                </div>
                <button
                  className="diamond-search-wrap-row 
                            advanced-options-accordian-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#advancedOptions"
                  aria-expanded="true"
                  aria-controls="advancedOptions"
                >
                  <span className="advanced-text">
                    {t("Advanced Options")}{" "}
                    <img src={base_assets + "images/icons/add-icon.png"} alt="" />
                  </span>
                  <span className="less-text">
                    {t("Less Options")}{" "}
                    <img
                      src={base_assets + "images/icons/minus-icon.png"}
                      alt=""
                    />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="diamond-search-wrap-nav">
          <div
            className="diamond-search-wrap-nav-tab"
            id="nav-tab"
            role="tablist"
          >
            <button
              className="nav-link active"
              id="nav-home-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-home"
              type="button"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true"
            >
              {t("results")}{" "}
              <span className="total-row">
                ({totalresult ? totalresult : ""})
              </span>
            </button>
            <button
              className="nav-link"
              id="nav-profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-profile"
              type="button"
              role="tab"
              aria-controls="nav-profile"
              aria-selected="false"
            >
              {t("Comparision")}{" "}
              <span className="total-row">
                ({comparisiondata ? comparisiondata?.length : "0"})
              </span>
            </button>
          </div>
          <div className="tab-content" id="nav-tabContent">
            <div
              className="tab-pane fade show active"
              id="nav-home"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <div className="common-sub-table-wrap add-row">
                <div className="main-body-main-table-wrap">
                  <table
                    id="tbl_createTransfer1"
                    className="common-table first-row-gray w-100"
                  >
                    <thead>
                      <tr>
                        <th />
                        <th>#</th>
                        <th>{t("Shape")}</th>
                        <th>{t("Carat")}</th>
                        <th>{t("Colour")}</th>
                        <th>{t("Clarity")}</th>
                        <th>{t("Cut")}</th>
                        <th>{t("Polish")}</th>
                        <th>{t("Symmetry")}</th>
                        <th>{t("Certificate")}</th>
                        <th>{t("Price")}</th>
                        <th>{t("Location")}</th>
                        <th className="text-center">{t("Detail")}</th>
                        <th className="text-center">{t("Status")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <>
                        {items.length
                          ? items.map((result, key) => {
                            return (
                              <tr key={key}>
                                <td>
                                  <div className={result?.Status === 2 ? "com-check checkbox-disabled" : "com-check"}>
                                    <input id={result?._id} data-id={"d" + result?._id} onClick={callcomparision} type="checkbox" />
                                    <label htmlFor={result?._id} className="com-check-label" />
                                  </div>
                                </td>
                                <td>{key + 1}</td>
                                <td className="diamond-pro-img">
                                  <img
                                    src={
                                      result?.Shape
                                        ? result?.Shape
                                        : base_assets +
                                        "images/icon/camera_profile.png"
                                    }
                                    alt=""
                                  />
                                </td>
                                <td>

                                  <Link
                                    className="link-color text-decoration-none"
                                    state={{
                                      daimondid: result?._id,
                                      items: state ? state?.items : '',
                                      itemchanges: state?.itemchanges,
                                      product_id: state?.product_id,
                                      bychangeorder: state?.bychangeorder,
                                      optiondetailid: state?.optiondetailid,
                                      Engraving: state?.Engraving,
                                      customcart: state?.customcart,
                                      order_edit: state?.order_edit,
                                      order_id: state?.order_id,
                                      order_type: state?.order_type,
                                      mixmatchedit: state?.mixmatchedit,
                                      editproduct: state?.editproduct,
                                      scrvicelist: state?.scrvicelist,
                                      scrviceremark: state?.scrviceremark,
                                      remark: state?.remark,
                                      mixMatchFlow:
                                        mixMatchFlowProp ?? state?.mixMatchFlow,
                                    }}
                                    to="/app/pos/custom/DiamondDetail"
                                  >
                                    {result?.Carat ? result?.Carat : ""}
                                  </Link>
                                </td>
                                <td>
                                  {result?.Colour ? result?.Colour : ""}
                                </td>
                                <td>
                                  {result?.Clarity ? result?.Clarity : ""}
                                </td>
                                <td>{result?.Cut ? result?.Cut : ""}</td>
                                <td>
                                  {result?.Polish ? result?.Polish : ""}
                                </td>
                                <td>
                                  {result?.Symmetry ? result?.Symmetry : ""}
                                </td>
                                <td>
                                  <Link
                                    className="link-color text-decoration-none"
                                    target="_blank"
                                    href={
                                      result?.CertificationUrl
                                        ? result?.CertificationUrl
                                        : ""
                                    }
                                  >
                                    {result?.Certification
                                      ? result?.Certification
                                      : ""}
                                  </Link>
                                </td>
                                <td>
                                  {result?.Price ? result?.Price : ""}
                                </td>
                                <td>
                                  {result?.Location ? result?.Location : ""}
                                </td>
                                <td className="text-center eye-img">
                                  <Link
                                    state={{
                                      daimondid: result?._id,
                                      items: state ? state?.items : '',
                                      itemchanges: state?.itemchanges,
                                      product_id: state?.product_id,
                                      bychangeorder: state?.bychangeorder,
                                      optiondetailid: state?.optiondetailid,
                                      Engraving: state?.Engraving,
                                      customcart: state?.customcart,
                                      order_edit: state?.order_edit,
                                      order_id: state?.order_id,
                                      order_type: state?.order_type,
                                      mixmatchedit: state?.mixmatchedit,
                                      editproduct: state?.editproduct,
                                      scrvicelist: state?.scrvicelist,
                                      scrviceremark: state?.scrviceremark,
                                      remark: state?.remark,
                                      mixMatchFlow:
                                        mixMatchFlowProp ?? state?.mixMatchFlow,
                                    }}
                                    to="/app/pos/custom/DiamondDetail"
                                     style={ result?.Status===3 ? { pointerEvents: "none", opacity: 0.4 } : {} }
                                  >
                                    <img
                                      src={
                                        base_assets +
                                        "images/icons/green-eye.png"
                                      }
                                      alt=""
                                    />
                                  </Link>
                                </td>

                                <td className='text-center'>
                                  <div className={result?.Status === 1 ? "status-yellow light-blue tooltip-area-up" : result?.Status === 2 ? "status-yellow light-yellow-bg tooltip-area-up" : result?.Status === 3 ? "status-yellow bg-danger tooltip-area-up" : "status-color bg-main-green tooltip-area-up"}>
                                    {
                                      result?.reserveDate ?
                                        <span className='tooltip-area-up-text'> {result?.customer}<br /> {formatDate(result?.reserveDate)} </span> :
                                        result?.Status === 1 ? <span className='tooltip-area-up-text'>{t("Stock")}</span> : result?.Status === 3 ?
                                          <span className='tooltip-area-up-text'>{t("Custom Order")}</span> : result?.Status === 4 ? <span className='tooltip-area-up-text'>{t("Transit")} </span> : ''
                                    }
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                          :
                          <tr>

                            <td colSpan="50" className="text-center">{showLoader ? <TableLoader /> : t("No Data Available In Table")}</td>
                          </tr>
                        }

                      </>
                    </tbody>
                  </table>
                  {totalresult > limit && totalresult > rowlength ?
                    <div className="show-more" >
                      <span className='show-more-displaying'>{t("Displaying")} {items?.length}  {t("of")} {totalresult} {t("items")}</span>
                      <button onClick={fetchMoreData} className='btn show-more-btn'>
                        {t("Show more")} <img src={base_assets + "images/icons/add-icon.png"} alt="" />
                      </button>
                    </div> : ""}
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="nav-profile"
              role="tabpanel"
              aria-labelledby="nav-profile-tab"
            >
              <div className="common-sub-table-wrap add-row">
                <div className="main-body-main-table-wrap">
                  <table
                    id="tbl_createTransfer2"
                    className="common-table first-row-gray w-100"
                  >
                    <thead>
                      <tr>
                        <th />
                        <th>#</th>
                        <th>{t("Shape")}</th>
                        <th>{t("Carat")}</th>
                        <th>{t("Colour")}</th>
                        <th>{t("Clarity")}</th>
                        <th>{t("Cut")}</th>
                        <th>{t("Polish")}</th>
                        <th>{t("Symmetry")}</th>
                        <th>{t("Certificate")}</th>
                        <th>{t("Price")}</th>
                        <th>{t("Location")}</th>
                        <th className="text-center">{t("Detail")}</th>
                        <th className="text-center">{t("Status")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <>
                        {comparisiondata.length
                          ? comparisiondata.map((result, key) => {
                            return (
                              <tr key={key}>
                                <td>
                                  <button
                                    className="delete-row-btn"
                                    onClick={() =>
                                      deletecomparision(result?._id)
                                    }
                                  >
                                    <img
                                      src={
                                        base_assets +
                                        "images/icons/delete-icon.png"
                                      }
                                      alt=""
                                    />
                                  </button>
                                </td>
                                <td>{key + 1}</td>
                                <td className="diamond-pro-img">
                                  <img
                                    src={
                                      result?.Shape
                                        ? result?.Shape
                                        : base_assets +
                                        "images/icon/camera_profile.png"
                                    }
                                    alt=""
                                  />
                                </td>
                                <td>
                                  <Link className="link-color text-decoration-none" href="">
                                    {result?.Carat ? result?.Carat : ""}
                                  </Link>
                                </td>
                                <td>{result?.Colour ? result?.Colour : ""}</td>
                                <td>
                                  {result?.Clarity ? result?.Clarity : ""}
                                </td>
                                <td>{result?.Cut ? result?.Cut : ""}</td>
                                <td>{result?.Polish ? result?.Polish : ""}</td>
                                <td>
                                  {result?.Symmetry ? result?.Symmetry : ""}
                                </td>
                                <td>
                                  <Link className="link-color text-decoration-none"
                                    target="_blank"
                                    href={
                                      result?.CertificationUrl
                                        ? result?.CertificationUrl
                                        : ""
                                    }
                                  >
                                    {result?.Certification
                                      ? result?.Certification
                                      : ""}
                                  </Link>
                                </td>
                                <td> {result?.Price ? result?.Price : ""}</td>
                                <td>
                                  {result?.Location ? result?.Location : ""}
                                </td>
                                <td className="text-center eye-img">
                                  <Link
                                    state={{
                                      daimondid: result?._id,
                                      items: state ? state?.items : '',
                                      itemchanges: state?.itemchanges,
                                      product_id: state?.product_id,
                                      bychangeorder: state?.bychangeorder,
                                      optiondetailid: state?.optiondetailid,
                                      Engraving: state?.Engraving,
                                      editproduct: state?.editproduct,
                                      customcart: state?.customcart,
                                      scrvicelist: state?.scrvicelist,
                                      scrviceremark: state?.scrviceremark,
                                      remark: state?.remark,
                                      mixMatchFlow:
                                        mixMatchFlowProp ?? state?.mixMatchFlow,
                                    }}
                                    to="/app/pos/custom/DiamondDetail"
                                  >
                                    <img
                                      src={
                                        base_assets +
                                        "images/icons/green-eye.png"
                                      }
                                      alt=""
                                    />
                                  </Link>
                                </td>

                                <td className='text-center'>
                                  <div className={result?.Status === 1 ? "status-yellow light-blue tooltip-area-up" : result?.Status === 2 ? "status-yellow light-yellow-bg tooltip-area-up" : result?.Status === 3 ? "status-yellow bg-danger tooltip-area-up" : "status-color bg-main-green tooltip-area-up"}>
                                    {
                                      result?.reserveDate ?
                                        <span className='tooltip-area-up-text'> {result?.customer} <br /> {formatDate(result?.reserveDate)} </span> :
                                        result?.Status === 1 ? <span className='tooltip-area-up-text'>{t("Stock")}</span> : result?.Status === 3 ?
                                          <span className='tooltip-area-up-text'>{t("Custom Order")}</span> : result?.Status === 4 ? <span className='tooltip-area-up-text'>{t("Transit")} </span> : ''
                                    }
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                          :
                          <tr>

                            <td colSpan="50" className="text-center">{comparisionLoader ? <TableLoader /> : t("No Data Available In Table")}</td>
                          </tr>
                        }

                      </>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
